import 'swiper/swiper-bundle.css';

import { Button, Icon, Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import qs from 'qs';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SwiperSlide } from 'swiper/react';

import { Swiper } from '@hero/atoms';
import { HomeTopCategoriesSkeletons } from '@hero/components/skeletons';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetCSEntries } from '@hero/services/content-stack-service/hooks';

import * as S from './style';

export function HomeTopCategories() {
  const { t } = useTranslation();
  const navigationNextRef = useRef(null);
  const navigationPrevRef = useRef(null);
  const swiper = useRef();
  const navigate = useNavigate();

  const {
    data: topCategories,
    isSuccess,
    isFetching
  } = useGetCSEntries({
    entryCode: 'sgb_admin_home_top_categories'
  });

  const params = {
    spaceBetween: 12,
    slidesPerView: 'auto',
    slidesPerGroup: 6,
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 4
    }
  };

  const sortedTopCategories = topCategories?.entries?.sort((a, b) => a.order - b.order);

  if ((isSuccess && !sortedTopCategories?.length) || isFetching) {
    return null;
  }

  return (
    <S.HomeTopCategoriesWrapper>
      <S.HeaderWrapper>
        <Typography variant="subtitle1Bold">{t('popularCategories')}</Typography>
        <VerticalDivider
          $margin="0 16px"
          $height="24px"
          color="var(--color-components-input-border-strong)"
        />
        <Button
          size="lg"
          variant="link"
          color="bg"
          onClick={() =>
            navigate(
              `${ROUTE_PATHS.GIFT_CATALOG}?${qs.stringify({
                categoryIds: [sortedTopCategories[0].category_id]
              })}`
            )
          }
        >
          {t('seeAll')}
        </Button>
      </S.HeaderWrapper>
      <S.HomeTopCategories>
        <S.NavigationButton color="secondary" variant="link" ref={navigationPrevRef}>
          <Icon name="left-chevron" size="lg" />
        </S.NavigationButton>

        {isFetching ? (
          <S.CategorySkeleton>
            <HomeTopCategoriesSkeletons />
          </S.CategorySkeleton>
        ) : (
          <Swiper
            ref={swiper}
            {...params}
            pagination={{
              clickable: true
            }}
          >
            {sortedTopCategories?.map(category => (
              <SwiperSlide
                style={{
                  width: 120,
                  height: 200,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                key={category.category_id}
              >
                <S.CategoryItem
                  as="div"
                  onClick={() => {
                    const search = qs.stringify({
                      categoryIds: [category.category_id]
                    });
                    navigate(`${ROUTE_PATHS.GIFT_CATALOG}?${search}`);
                  }}
                >
                  <S.CategoryImage src={category.image?.url} height="80px" width="80px" />
                  <S.CategoryName variant="body2Bold">{category?.name}</S.CategoryName>
                </S.CategoryItem>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        <S.NavigationButton color="secondary" variant="link" ref={navigationNextRef}>
          <Icon name="right-chevron" size="lg" />
        </S.NavigationButton>
      </S.HomeTopCategories>
    </S.HomeTopCategoriesWrapper>
  );
}
